import {AppState} from "../db/model";

export const isCorrectEmail = (appState: AppState): boolean => {
  const primaryEmail = appState.session?.user?.primaryEmail ?? ''
  return primaryEmail !== '' && primaryEmail === appState.application?.email
}